import React from "react";

export default function Webflow() {
  return (
    <div className="flex flex-col mt-20 mb-10">
      <section className="bg-black text-white py-20">
        <div className="container mx-auto flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 px-4 text-center md:text-left">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Webflow Design & Development Services
            </h1>
            <p className="mb-6 text-sm md:text-base">
              Is your website maintenance headache driving you crazy? Are you
              spending countless hours and money on frequent updates to keep it
              safe and secure? You can get out of this pain with Webflow's
              internal hosting.
            </p>
            <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full">
              Your Webflow website!
            </button>
          </div>
          <div className="md:w-1/2 px-4 mt-8 md:mt-0">
            <img
              src="https://placehold.co/600x400"
              alt="Abstract 3D shape with reflective surfaces"
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      <section className="bg-white text-black py-20">
        <div className="container mx-auto flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 px-4 order-2 md:order-1 mt-8 md:mt-0">
            <img
              src="https://placehold.co/600x400"
              alt="Webflow design examples"
              className="w-full h-auto"
            />
          </div>
          <div className="md:w-1/2 px-4 order-1 md:order-2 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Get a professional website in just a week with Webflow!
            </h2>
            <p className="mb-6 text-sm md:text-base">
              Stop struggling with messy web builders. Webflow's visual
              interface lets entrepreneurs like you launch professional websites
              in 7 days. We design, you shine. Ready to impress your users?
            </p>
            <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full">
              FREE Webflow consultation!
            </button>
          </div>
        </div>
      </section>

      <section className="bg-black text-white py-20">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6">
          <div className="md:w-1/2">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Is your website fast but frustrating? Prioritize
              user-friendliness!
            </h1>
            <p className="mb-6 text-sm md:text-base">
              Your website needs more than just performance and security. It
              needs to be intuitive and easy to use. A Webflow ensures speed and
              security, we deliver the experience your users expect.
            </p>
            <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded">
              Build Webflow site!
            </button>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0">
            <img
              src="https://placehold.co/600x400"
              alt="Collage of various website designs"
              className="w-full h-auto rounded"
            />
          </div>
        </div>
      </section>

      <section className="bg-gray-100 py-20">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-10">
            Range of our Webflow design and development solutions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 px-6">
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="Custom Design"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">Custom Design</h3>
              <p>
                Your unique needs, your custom website. With Webflow, you can
                get your personalized site quicker than ever.
              </p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="E-commerce"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">E-commerce</h3>
              <p>
                Get your payment-secure web store built with Webflow, which is
                fast-loading, SEO-friendly, and ready to convert.
              </p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="Third-party Integration"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">
                Third-party Integration
              </h3>
              <p>
                Want to save time and boost your productivity? Easily integrate
                your Webflow site and CMS with our smart integration solution.
              </p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="Performance Optimization"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">
                Performance Optimization
              </h3>
              <p>
                Don’t let slow loading times ruin your website. With Webflow,
                you can optimize your site’s performance and deliver a smooth
                experience.
              </p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="SEO Optimization"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">SEO Optimization</h3>
              <p>
                Increase your Webflow website’s search engine visibility with
                built-in SEO tools and lightning-fast load times.
              </p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <img
                src="https://placehold.co/100x100"
                alt="On-going Maintenance"
                className="mx-auto mb-4"
              />
              <h3 className="text-xl font-bold mb-2">On-going Maintenance</h3>
              <p>
                Your site shouldn’t crash or lag. We ensure a flawless Webflow
                experience for your users.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-black text-white py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-6xl mx-auto">
          <div className="bg-yellow-400 p-10 text-black text-5xl font-bold">
            300k
            <p className="text-lg mt-2">raised funds within 6 months!</p>
          </div>
          <div className="bg-white p-10 text-black text-5xl font-bold">
            17%
            <p className="text-lg mt-2">
              reduction in churn rate due to enhanced user experience and
              engaging visuals.
            </p>
          </div>
          <div className="bg-green-400 p-10 text-black text-5xl font-bold">
            +31%
            <p className="text-lg mt-2">
              client conversion increased after giving Steptranport a design
              upgrade!
            </p>
          </div>
          <div className="bg-gray-800 p-10 text-white">
            <p className="text-2xl font-bold">STEP</p>
            <p className="text-xl">Steptranport - Seamless Operations</p>
            <button className="mt-4 bg-yellow-400 text-black px-4 py-2 rounded">
              Get Webflow success!
            </button>
            <img
              src="https://placehold.co/300x200"
              alt="Image of Steptranport operations"
              className="mt-4"
            />
          </div>
        </div>
      </div>

 <div className="bg-white py-20">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 pr-0 md:pr-10 mb-10 md:mb-0">
            <p className="text-sm text-gray-500">
              LOOKING FOR A PLUG-AND-PLAY WEBSITE?
            </p>
            <h2 className="text-4xl font-bold mt-2">
              Take the first step toward your desired website with Webflow!
            </h2>
            <p className="text-lg mt-4">
              Get your website done with Webflow so you can easily manage
              yourself. Our Webflow experts can help you stand out in the crowd
              with the UI-driven approach.
            </p>
            <button className="mt-4 bg-yellow-400 text-black px-4 py-2 rounded">
              Your Webflow success!
            </button>
          </div>
          <div className="w-full md:w-1/2">
            <img
              src="https://placehold.co/500x300"
              alt="Image of a computer screen with Webflow interface"
            />
          </div>
        </div>
      </div>

      <section className="bg-gray-200 py-12">
        <div className="text-center mb-8">
          <span className="bg-green-500 text-white px-2 py-1 rounded-full">
            Show more cases
          </span>
          <h2 className="text-2xl font-bold mt-4">
            Get the real story, not just our words!
          </h2>
        </div>
        <div className="flex flex-wrap justify-center space-x-0 md:space-x-4">
          <div className="bg-white p-6 rounded-lg shadow-md w-full md:w-1/5 mb-4 md:mb-0">
            <p className="text-gray-700 mb-4">
              We were happy that we found the best UI/UX Design agency and best
              product design agency to work with. We will definitely continue to
              work with them as we have greatest output.
            </p>
            <div className="flex items-center">
              <img
                src="https://placehold.co/40"
                alt="Profile picture of Nedim Zekirovic"
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-bold">Nedim Zekirovic</p>
                <p className="text-gray-500">Co-founder, Kroon</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md w-full md:w-1/4 mb-4 md:mb-0">
            <p className="text-gray-700 mb-4">
              Their ability to produce high-quality, on-brand design elements
              and animation within days was a game changer!
            </p>
            <div className="flex items-center">
              <img
                src="https://placehold.co/40"
                alt="Profile picture of Nicolas Grasset"
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-bold">Nicolas Grasset</p>
                <p className="text-gray-500">CEO, Peel</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md w-full md:w-1/4 mb-4 md:mb-0">
            <p className="text-gray-700 mb-4">
              Musemind developed a product roadmap, user flows, wireframes, and
              high-fidelity designs, all tuned to the requirements of our three
              user types, prioritizing user-friendliness.
            </p>
            <div className="flex items-center">
              <img
                src="https://placehold.co/40"
                alt="Profile picture of Ewen Ling"
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-bold">Ewen Ling</p>
                <p className="text-gray-500">Founder & CEO, Refenso</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md w-full md:w-1/4 mb-4 md:mb-0">
            <p className="text-gray-700 mb-4">
              Musemind swiftly delivered content in two weeks, meeting client
              expectations, and managing workflow and communication efficiently
              and positively.
            </p>
            <div className="flex items-center">
              <img
                src="https://placehold.co/40"
                alt="Profile picture of Yaqin Liu"
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-bold">Yaqin Liu</p>
                <p className="text-gray-500">Product Manager at Lingbing</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-green-500 py-12">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-full w-1/2 mb-8 md:mb-0">
            <h2 className="text-2xl font-bold text-black mb-4 mr-10">
              Why choose us to build your Webflow website?
            </h2>
            <p className="text-black mb-4">
              We never regretted migrating from WordPress to Webflow. Why? We’ve
              already done it successfully for more than 50 businesses. And it
              was a game-changing decision for them. We can do the same for you.
            </p>
            <button className="bg-black text-white px-4 py-2 rounded-full">
              Build Webflow site
            </button>
          </div>
          <div className="w-full md:w-1/2">
            <img
              src="https://placehold.co/400x300"
              alt="Laptop showing a Webflow website"
              className="rounded-lg shadow-md"
            />
          </div>
        </div>
      </section>
    </div>
  );
}